import inboundIcon from '../../assets/inbound.svg';
import inboundIconDark from '../../assets/inbound_dark.svg';

export function InboundIcon({
  size = 18,
  title,
  filter,
  theme = 'white',
}: {
  size?: number;
  title?: string;
  filter?: string;
  theme?: 'white' | 'dark';
}) {
  return (
    <img
      src={theme === 'white' ? inboundIcon : inboundIconDark}
      alt="Inbound Fax"
      title={title}
      style={{
        width: size,
        height: size,
        filter: filter,
      }}
    />
  );
}
